import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const eobDocumentsSelector = (state: RootState) => state.visitSummary.eob;

export const eobDocumentsDataSelector = createSelector(eobDocumentsSelector, hd => hd.data);

export const eobDocumentsFetchingSelector = createSelector(
  eobDocumentsSelector,
  hd => hd.isFetching
);

export const eobDocumentsErrorSelector = createSelector(eobDocumentsSelector, hd => hd.error);

/**
 * Download eob
 */
export const eobDownloadSelector = (state: RootState) => state.visitSummary.eobDownloads;

export const eobDownloadingSelector = createSelector(
  eobDownloadSelector,
  eobDownloads => eobDownloads.isDownloading
);
